import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/plat/admin/track/reportTable/"

function baseApi() {

    function insert(data) {
        return Post(baseUrl + "insertTrackReportSetting", data)
    }

    function deleteData(data) {
        return Post(baseUrl + "deleteTrackReportSetting", data)
    }

    function update(data) {
        return Post(baseUrl + "updateTrackReportSetting", data)
    }

    function query(data) {
        return Post(baseUrl + "queryTrackReportSetting", data)
    }

    function queryOne(data) {
        return Post(baseUrl + "queryOneTrackReportSetting", data)
    }

    return {
        insert,
        deleteData,
        update,
        query,
        queryOne
    }
}

export const trackReportSettingApi = baseApi()